import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const LOYALTY_API_PATH = '/api/loyalty';

const redeemPoints = async (customerId, pointsToRedeem) => {
  const response = await axios.post(`${API_BASE_URL}${LOYALTY_API_PATH}/redeem`, { customerId, pointsToRedeem });
  return response.data.data;
};

const loyaltyService = {
  redeemPoints,
};

export default loyaltyService;